import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massRestoreWhyChooseUsItems } from "../../api/apiWhyChooseUs";
import parseError from "../../utils/parseError";

export function useRestoreAllWhyChooseUsItems() {
    const queryClient = useQueryClient();

    const { mutate: restoreAllItemsMutate, isPending } = useMutation({
        mutationFn: massRestoreWhyChooseUsItems,
        onSuccess: (response) => {
            toast.success(response.message || "Restored successfully");
            queryClient.invalidateQueries({ queryKey: ["why-choose-us-items"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore items");
        },
    });

    return { restoreAllItemsMutate, isPending };
}
